import React from 'react';
import { ControlIcons } from '@/Static/IconsRes';
import { Icon } from '@/Components/Icon/Icon';
import Button from 'devextreme-react/button';
import styles from './TableSearchButton.scss';
import { useLocalization } from '@/Hooks';
import { Tooltip } from '@/Components/Tooltip/Tooltip';

type Props = {
  onClick: () => void;
};

export const TableSearchButton = ({ onClick }: Props): React.ReactElement => {
  const {
    common: {
      Actions: { ColumnFilter },
    },
  } = useLocalization();

  return (
    <Tooltip text={ColumnFilter}>
      <Button className={styles.button} onClick={onClick}>
        <Icon alt="showTableSearch" src={ControlIcons.TableSearch} className={styles.icon} />
      </Button>
    </Tooltip>
  );
};
